import { ReactNode } from "react";
import Currency from "../../../../../components/currency/currency";
import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../components/fonts/font-props";
import { IMoneyDto } from "../../rma-types";
import { Tooltip } from "../../../../../components/tooltip/tooltip";
import Icon from "../../../../../components/icons/icon/icon";
import IconInfo from "../../../../../components/icons/icon-info/icon-info";
import "./rma-not-zero-money-amount.scss";

interface IProps {
    title: string;
    moneyDto?: IMoneyDto;
    color?: FONT_COLOR;
    amountFontVariant?: FONT_VARIANT | FONT_VARIANT[];
    useColon?: boolean;
    subItem?: boolean;
    tooltipContent?: ReactNode;
}

const RmaNotZeroMoneyAmount: React.FC<IProps> = ({
    title,
    moneyDto,
    color,
    useColon,
    subItem,
    tooltipContent,
    amountFontVariant,
}) => {
    if (!moneyDto || moneyDto.amount === 0) {
        return null;
    }

    return (
        <div className={`not-zero-money-amount ${subItem ? 'sub-item' : ''}`}>
            <div className={`not-zero-money-amount-container`}>
                <div className="not-zero-money-amount-title">
                    <FontBody2 color={color}>
                        {`${title}`}{useColon ? ': ' : ''}
                    </FontBody2>
                    {tooltipContent && <Tooltip content={
                        <FontBody2 color={color}>{tooltipContent}</FontBody2>
                    }>
                        <Icon Component={IconInfo} />
                    </Tooltip>}
                </div>
                <FontBody2 color={color} variant={amountFontVariant}>
                    <Currency
                        currencyCode={moneyDto.currency_code}
                        amount={moneyDto.amount}
                    />
                </FontBody2>
            </div>
        </div>
    );
}

export default RmaNotZeroMoneyAmount;

